import { ICON__check } from '@/assets/icons_fa';
import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import { UI_PRIMITIVE__input } from '@/components/ui/UI_PRIMITIVE__input';
import { ENUM__component_type } from '@/enums/ENUM__component_type';
import { ENUM__html_ref_stub } from '@/enums/ENUM__html_ref_stub';
import { Key } from '@/enums/key';
import { HOOK__notifier } from '@/hooks/HOOK__notifier';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_ref_with_fallback } from '@/hooks/_base/use_ref_with_fallback';
import { use_slice_ui } from '@/hooks/store/use_slices';
import { remote_user_task_update_name } from '@/state/generation/user_task/entity/remote_user_task_update_name';
import { LOCAL__ui_set_string } from '@/state/ui/_base/LOCAL__ui_set_string';
import { local_ui_page_tasks_set_new_task_id } from '@/state/ui/page_tasks/local_ui_page_tasks_set_new_task_id';
import { ENUM__string_id_empty } from '@shared/constants/ENUM__string_id_empty';
import { ENUM__workspace_entity } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity';
import { DTO__user_task } from '@shared/dto/user_task/DTO__user_task';
import React, { useState } from 'react';

interface Props {
  user_task: DTO__user_task;
  set_is_edit_name: (value: boolean) => void;
}

export function U_INPUT__user_task_name({ user_task, set_is_edit_name }: Props) {
  const dispatch = use_dispatch();

  const { page_tasks_new_task_id } = use_slice_ui(['page_tasks_new_task_id']);

  /*
   *
   */
  const component_id = `${ENUM__component_type.PAGE_USER_TASKS_LIST_ITEM_TITLE}_${user_task._id}`;
  const notifier = HOOK__notifier(component_id, ENUM__workspace_entity.ENTITY_USER_TASK);

  const [value, set_value] = useState(user_task.name);

  const ref_input = use_ref_with_fallback(ENUM__html_ref_stub.INPUT);
  const ref_button = use_ref_with_fallback(ENUM__html_ref_stub.BUTTON);

  /*
   * EFFECTS
   */
  use_effect(() => {
    if (page_tasks_new_task_id.is_empty_object_id()) {
      ref_input.current.focus();

      // Set cursor position to the end of the text
      const { length } = ref_input.current.value;
      ref_input.current.setSelectionRange(length, length);

      dispatch(LOCAL__ui_set_string({ key: 'page_tasks_new_task_id', value: ENUM__string_id_empty.OBJECT_ID, valid_values: [] }));
    } else {
      ref_input.current.select();
    }
  });

  /*
   * EVENTS
   */
  function onBlur(e: React.FocusEvent<HTMLInputElement> | null = null) {
    if (e?.relatedTarget == ref_button.current) return;

    set_is_edit_name(false);
    dispatch(local_ui_page_tasks_set_new_task_id(''));
  }

  async function onKeyDown(e: React.KeyboardEvent<HTMLInputElement>) {
    if (e.key === Key.Enter) await onEnterPressed(e);

    if (e.key === Key.Escape) {
      e.preventDefault();
      onBlur();
    }
  }

  async function onEnterPressed(e: React.KeyboardEvent<HTMLInputElement> | null = null) {
    e?.preventDefault();

    e?.stopPropagation();

    let value_new = value.trim();

    set_is_edit_name(false);

    if (value_new.is_blank()) return;

    if (user_task.name != value_new) {
      user_task.name = value_new;
      // const trancateValue = nameNew.length > 30 ? nameNew.slice(0, 30) + '...' : nameNew;
      set_value(value_new);
      await dispatch(remote_user_task_update_name(user_task));

      await notifier.send_action();
    }
    dispatch(local_ui_page_tasks_set_new_task_id(''));
  }

  /*
   * HTML
   */

  return (
    <div className="list-item-wrapper relative px-0">
      <UI_PRIMITIVE__input
        ref={ref_input}
        // maxLength={30}
        {...{ onBlur, value, onKeyDown }}
        onChange={e => set_value(e.target.value)}
        className="bg-component-item-selected rounded-lg max-h-9 outline-none border-none pl-3 pr-9 focus:max-h-9 md:text-base"
        autoFocus
      />
      <UI_PRIMITIVE__button
        ref={ref_button}
        className="w-7 absolute top-2.5 right-3"
        size="square-5"
        variant="no-border-on-component"
        onClick={() => onEnterPressed()}
      >
        <ICON__check className="!w-3 !h-3" />
      </UI_PRIMITIVE__button>
    </div>
  );
}
